import MainLogo from "../assets/images/FRS New Logo Blue Cropped.png";
import MainLogoShield from "../assets/images/FRS_logo_shield.png";
import ProfileIcon from "../assets/images/profile_icon.svg";
import SidebarFooterIcon from "../assets/images/sidebar_icon.svg";
import CommingSoonImage from "../assets/images/comming_soon.svg";
import ProfileImage from "../assets/images/profile_image.png";
import EmptyImage from "../assets/images/empty.svg";
import LeftArrowIcon from "../assets/images/caret-left-fill.svg";
import RightArrowIcon from "../assets/images/caret-right-fill.svg";
import GreenTick from "../assets/images/green_tick_icon.png";
import MainLogoWhite from "../assets/images/FRS_Logo_White.png";
import AIRobot from "../assets/images/ai_robot.svg";
import DataNotFound from "../assets/images/data_not_found.svg";
import FormFilling from "../assets/images/form_filling.svg";
import RoboticImage from "../assets/images/robotic_image.svg"
import SuccessImage from "../assets/images/success_image.svg";
import PersonAwards from "../assets/images/person_awards.svg";

export const MAIN_LOGO = MainLogo;
export const MAIN_LOGO_SHIELD = MainLogoShield;
export const PROFILE_ICON = ProfileIcon;
export const SIDEBAR_FOOTER_ICON = SidebarFooterIcon;
export const COMMING_SOON_IMAGE = CommingSoonImage;
export const PROFILE_IMAGE = ProfileImage;
export const EMPTY_IMAGE = EmptyImage;
export const LEFT_ARROW = LeftArrowIcon;
export const RIGHT_ARROW = RightArrowIcon;
export const GREEN_TICK = GreenTick;
export const MAIN_LOGO_WHITE = MainLogoWhite;
export const AI_ROBOT = AIRobot;
export const DATA_NOT_FOUND = DataNotFound;
export const FORM_FILLING = FormFilling;
export const ROBOTICS_IMAGE = RoboticImage;
export const SUCCESS_IMAGE = SuccessImage;
export const PERSON_AWARD = PersonAwards;
